import React from 'react'
import { BrowserRouter } from "react-router-dom";


import AppContext from "./Context/AppContext";
import Routing from '../src/routing/index'
const App = () => {
  return (
    <AppContext>
      <BrowserRouter>

        <Routing />
      </BrowserRouter>

    </AppContext>
  )
}

export default App
